import { NotificationInline, OverlayLoader } from '@coop/components';

import type { ApiProduct } from '../../../../models/ecommerce/product/ApiProduct';
import { useSubstitutes } from '../../../recipe/hooks/useSubstitutes';
import type { RecipeItemState } from '../../../recipe/models';
import { useCurrentPriceType } from '../../hooks/useCurrentPriceType';
import { ProductSubstitutes } from '../ProductSubstitutes';

const RecipeProductSubstitutes = (props: {
    navigationSlot: React.ReactNode;
    belowHeaderSlot?: React.ReactNode;
    items: RecipeItemState[];
    substituteIdentifier: string;
    isLoading: boolean;
    onSubstituteChangeClick: (item: RecipeItemState, product: ApiProduct) => void;
    onSubstituteProductSuccess?: () => void;
}) => {
    const { onSubstituteChangeClick, subsitutesQuery } = useSubstitutes(
        props.onSubstituteChangeClick,
        props.items,
        props.onSubstituteProductSuccess,
        props.substituteIdentifier,
    );

    const { currentPriceType } = useCurrentPriceType();
    const itemToChange = props.items.find(
        (item) => item.substituteIdentifier === props.substituteIdentifier,
    );

    return (
        <div
            style={{
                isolation: 'isolate',
                overflowY: 'auto',
                overflowX: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }}
        >
            <ProductSubstitutes
                navigationSlot={props.navigationSlot}
                belowHeaderSlot={
                    <>
                        <OverlayLoader isLoading={props.isLoading} />
                        <NotificationInline
                            variant="critical"
                            className="u-marginTsm u-marginHmd"
                            role="alert"
                            animated={false}
                            show={!!subsitutesQuery.error}
                            message="Vi kunde inte ladda produkter"
                        />
                        <NotificationInline
                            variant="warning"
                            className="u-marginTsm u-marginHmd"
                            role="status"
                            animated={false}
                            show={
                                subsitutesQuery.isSuccess &&
                                subsitutesQuery.data.substitutes.length === 0
                            }
                            message="Vi kunde hitta några ersättare för den här produkten"
                        />
                    </>
                }
                substitutes={subsitutesQuery.data?.substitutes || []}
                onProductSubstitution={(newProduct) => {
                    if (itemToChange) {
                        onSubstituteChangeClick(itemToChange, newProduct);
                    }
                }}
                priceType={currentPriceType}
                productName={itemToChange?.name || ''}
                isLoading={subsitutesQuery.isLoading}
            />
        </div>
    );
};

export default RecipeProductSubstitutes;
